export default __webpack_public_path__ + "static/media/dropout.png.webp";